module.exports = __webpack_public_path__ + "static/media/16(3).ad5b87bb.jpg";